export default __webpack_public_path__ + "static/media/tap_here_bottom.d2aa61ee.png";